import React from "react";
import './infos.scss';

import photo from './assets/setembro-amarelo.png';

export default function Infos(){
  return(
    <>
      <section id="background-info">
        <div className = "container d-flex">
          <figure className="box"
              data-aos="fade-zoom-in" 
              data-aos-duration="1000"
              data-aos-delay="300"
              data-aos-offse="0" >
            <img src={photo} width = "70" alt="janeiro branco - Séculos Engenharia" />
          </figure>
          <div className="box"
              data-aos="fade-zoom-in" 
              data-aos-duration="1000"
              data-aos-delay="300"
              data-aos-offse="0" >
            <h2>
              <b className="negrito">setembro</b>
            </h2>
            <div className="box-2">
              <h3 className="orang"><b>amarelo</b></h3>
              {/* <h3 className="purpple"><b>roxo</b></h3> */}
              <p className="text">
                Sua vida é única,
                <b> setembro amarelo </b>
                é para lembrar
                disso.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}